import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { useConnectModal } from "../../../components/Wallet/WalletModal";
import VaulDrawer from "../../../components/Modal/vaulModal";
import { ChevronDown, Plus } from "lucide-react";
import { WalletItem } from "../../../components/Wallet/WalletComponents/WalletsList";
import { WalletIcon } from "@layerswap/ui-kit/components";
import WalletIconView from "../../../components/Wallet/WalletIconView";
import ConnectButton from "../../../components/Buttons/connectButton";
import { WalletsIcons } from "../../../components/Wallet/WalletComponents/ConnectedWallets";
import { useFormikContext } from "formik";
import { useSwapAccounts, useSelectSwapAccount } from "../../../context/swapAccounts";
import { Address } from "../../../lib/address/Address";
import { useNamedAddress } from "../../../stores/addressBookStore";
const PickerWalletConnect = ({ direction }) => {
    const [openModal, setOpenModal] = useState(false);
    const { values, setFieldValue } = useFormikContext();
    const swapAccounts = useSwapAccounts(direction);
    const selectSwapAccount = useSelectSwapAccount(direction);
    const { connect } = useConnectModal();
    const connectWallet = async () => {
        const result = await connect();
        if (result)
            handleSelectAccount({
                walletId: result.id,
                address: result.address,
                providerName: result.providerName
            });
    };
    const handleSelectAccount = (props) => {
        const { walletId, address, providerName } = props;
        if (direction == 'to' && Address.isValid(address, values.to))
            setFieldValue(`destination_address`, address);
        selectSwapAccount({
            id: walletId,
            address,
            providerName,
        });
        setOpenModal(false);
    };
    return _jsxs(_Fragment, { children: [_jsx(AccountsPickerButton, { accounts: swapAccounts, network: direction === 'from' ? values.from : values.to, onOpenModalClick: () => setOpenModal(true) }), _jsx(VaulDrawer, { show: openModal, setShow: setOpenModal, header: 'Select wallet', modalId: "connectedWallets", children: _jsxs(VaulDrawer.Snap, { id: "item-1", className: "space-y-1 pb-4", children: [_jsx("button", { type: 'button', onClick: connectWallet, className: "w-full flex justify-center p-2 bg-secondary-500 rounded-md hover:bg-secondary-400", children: _jsxs("div", { className: "flex items-center text-secondary-text gap-1 px-3 py-1", children: [_jsx(Plus, { className: "h-4 w-4" }), _jsx("span", { className: "text-sm", children: "Connect new wallet" })] }) }), swapAccounts.map((account, index) => {
                            return (_jsxs("div", { children: [_jsx("div", { className: "flex justify-between items-center px-4 pt-2", children: _jsx("label", { htmlFor: "From", className: "block font-medium text-secondary-text text-sm pl-1 py-1", children: account.provider.name }) }), _jsx(AccountsList, { network: direction === 'from' ? values.from : values.to, onSelect: handleSelectAccount, selectedAccount: account }, index)] }, index));
                        })] }) })] });
};
const AccountsPickerButton = ({ accounts, network, onOpenModalClick }) => {
    const firstWallet = useMemo(() => accounts[0], [accounts]);
    const accountLabel = useNamedAddress(firstWallet?.address, null, firstWallet?.providerName);
    if (accounts.length > 0) {
        return _jsx("button", { onClick: onOpenModalClick, type: "button", className: "p-1.5 max-sm:p-2 justify-self-start text-secondary-text hover:bg-secondary-500 max-sm:bg-secondary-500 hover:text-primary-text focus:outline-hidden inline-flex rounded-lg items-center active:animate-press-down", children: accounts.length === 1 ?
                _jsxs("div", { className: "flex gap-2 items-center text-sm text-secondary-text", children: [_jsx(WalletIconView, { wallet: firstWallet, className: 'h-5 w-5', size: 20 }), firstWallet.address &&
                            _jsx("p", { className: "truncate max-w-[90px]", children: accountLabel }), _jsx(ChevronDown, { className: "h-5 w-5" })] })
                :
                    _jsx(WalletsIcons, { wallets: accounts }) });
    }
    return (_jsx(ConnectButton, { children: _jsx("div", { className: "p-1.5 max-sm:p-2 justify-self-start text-secondary-text hover:bg-secondary-500 max-sm:bg-secondary-500 hover:text-primary-text focus:outline-hidden inline-flex rounded-lg items-center active:animate-press-down", children: _jsx(WalletIcon, { className: "h-6 w-6 mx-0.5", strokeWidth: "2" }) }) }));
};
const AccountsList = (props) => {
    const { selectedAccount, onSelect, network } = props;
    const provider = selectedAccount?.provider;
    const connectedWallets = provider?.connectedWallets || [];
    const networkName = provider?.autofillSupportedNetworks ? { name: provider?.autofillSupportedNetworks[0] } : undefined;
    const walletNetwork = network || networkName;
    const isAccountDuplicate = selectedAccount && walletNetwork && connectedWallets.some((w) => w.addresses.some((address) => Address.equals(address, selectedAccount.address, walletNetwork)));
    const accounts = [
        ...connectedWallets,
        ...(selectedAccount && !isAccountDuplicate ? [selectedAccount] : [])
    ];
    return (_jsx("div", { className: "space-y-3", children: accounts.length > 0 &&
            _jsx("div", { className: "flex flex-col justify-start gap-2 rounded-xl", children: accounts.map((wallet, index) => _jsx(WalletItem, { account: wallet, selectable: true, onWalletSelect: onSelect, selectedAddress: selectedAccount?.address }, `${index}${wallet.providerName}`)) }) }));
};
export default PickerWalletConnect;
